<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div class="ts-grid ts-grid-cols-2 ts-gap-3">
      <div>
        <label class="required">{{ $t('wholesale.paymentMethod') }}</label>
        <a-select
          v-model.number="model.payment_method_id"
          @change="onPaymentMethodChange()"
          :options="paymentMethodOptions"
          class="ts-w-full"
        >
        </a-select>
        <div class="validate" v-if="errors.has('payment_method_id')">
          {{ errors.first('payment_method_id') }}
        </div>
      </div>
      <div>
        <label :class="{ required: model.payment_method_id !== 1 }">{{
          $t('wholesale.bankName')
        }}</label>
        <a-select
          v-model.number="model.bank_name"
          :options="bankNameOptions"
          @change="bankNameChange"
          :disabled="!isShow([2, 3, 4])"
          :loading="waiting"
          class="ts-w-full"
        ></a-select>
        <div class="validate" v-if="errors.has('bank_name')">
          {{ errors.first('bank_name') }}
        </div>
      </div>
    </div>
    <div class="ts-grid ts-grid-cols-1 ts-gap-3">
      <div>
        <label :class="{ required: model.payment_method_id !== 1 }">{{
          $t('wholesale.accountNumber')
        }}</label>
        <a-select
          v-if="!isShow([2])"
          v-model="model.account_number"
          :options="accountOptions"
          showSearch
          :filterOption="
            (input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
          "
          @change="accountChange"
          class="ts-w-full"
          :disabled="notDisableFor([3, 4])"
        ></a-select>
        <input type="text" class="form-control" v-if="isShow([2])" />
        <div class="validate" v-if="errors.has('account_number')">
          {{ errors.first('account_number') }}
        </div>
      </div>
      <!-- <div>
        <label class="required">{{ $t('wholesale.accountName') }}</label>
        <input
          v-model="model.account_name"
          type="text"
          class="form-control"
          :readonly="isShow([1])"
        />
        <div class="validate" v-if="errors.has('account_name')">
          {{ errors.first('account_name') }}
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'paymentMethod',
  props: ['value', 'validate'],
  data() {
    return {
      paymentMethods: [],
      errors: new Errors(),
      waiting: false,
      bankProfiles: [],
      model: {}
    }
  },
  computed: {
    paymentMethodOptions() {
      if (this.paymentMethods) {
        return this.paymentMethods.map(pm => ({
          value: pm.payment_method_id,
          label: pm.payment_method
        }))
      }
      return []
    },
    isShow: vm => arrayValue => {
      return _.includes(arrayValue, vm.model.payment_method_id)
    },
    notDisableFor: vm => arrayValue => {
      return !_.includes(arrayValue, vm.model.payment_method_id)
    },
    bankNameOptions() {
      return this.bankProfiles.map(el => ({
        value: el.bank_name,
        label: el.bank_name
      }))
    },
    accountOptions() {
      let acc = this.bankProfiles.filter(
        b => b.bank_name == this.model.bank_name
      )[0]
      if (acc) {
        return acc.accounts.map(el => ({
          value: el.account_number,
          label: el.prefix
            ? el.prefix + ' - ' + el.account_number + ' - ' + el.account_name
            : el.account_number + ' - ' + el.account_name,
          name: el.account_name
        }))
      }
      return []
    }
  },
  created() {
    this.model = this.value
    this.fetchResource()
  },
  methods: {
    ...mapActions('wholesale/operation', ['bankProfile', 'paymentMethod']),
    onPaymentMethodChange(value) {
      this.fetchBank()
    },
    fetchResource() {
      this.loading = true
      this.paymentMethod()
        .then(response => {
          this.paymentMethods = response.data
          this.onPaymentMethodChange()
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchBank() {
      if (this.model.payment_method_id != 1) {
        this.waiting = true
        this.bankProfile()
          .then(response => {
            this.bankProfiles = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.waiting = false
          })
      } else {
        this.model.bank_name = null
        this.model.account_number = null
        this.model.account_name = null
      }
    },
    bankNameChange() {
      this.model.account_number = null
      this.model.account_name = null
    },
    accountChange(value, opt) {
      this.model.account_name = opt.data.props.name
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
